
export const status = [
  {
    value: "Decision Pending",
  },
  {
    value: "Denied",
  },
  {
    value: "Approved",
  },
  {
    value: "Canceled",
  },
];

export const units = [
  {
    value: "Test 1",
  },
  {
    value: "Test 2",
  },
  {
    value: "Test 3",
  },
  {
    value: "Test 4",
  },
];

export const users = [
  {
    value: "user 1",
  },
  {
    value: "user 2",
  },
  {
    value: "user 3",
  },
  {
    value: "user 4",
  },
];

export const yearss = [
  {
    value: "Less than 1",
  },
];

for (let i = 1; i <= 50; i++) {
  yearss.push({
    value: i,
  },);
}

export const accountType = [
  {
    value: "Checking"
  },
  {
    value: "Saving"
  },
  {
    value: "Other"
  },
];
